import { ActiveEmptyState } from "@/ui/organisms";
import { useLabelingEmptyState } from "../hooks/useLabelingEmptyState";
import { useFileList } from "../hooks/useFileList";
import { Spinner } from "@/ui";

export function LabelingEmptyState() {
    const { quickActions } = useLabelingEmptyState();
    const { files, isLoading } = useFileList();

    if (files.length === 0 && isLoading) {
        return <Spinner fullScreen />;
    }

    let description =
        "User has no files available. When data is connected or files uploaded, files will appear here.";

    if (files.length > 0) {
        description =
            "Search for a file on the left or use one of the quick actions below.";
    }

    return (
        <ActiveEmptyState.Container title="Labeling" description={description}>
            {/* {recentlyViewed.length > 0 && (
                <div className="flex flex-col gap-4">
                    <ActiveEmptyState.RecentlyViewedList>
                        {recentlyViewed.map((item) => (
                            <ActiveEmptyState.RecentlyViewedItem
                                href={item.href}
                                key={item.fileSnapshot.id}
                            >
                                <div
                                    className={clsx(
                                        "flex flex-1 flex-col",
                                        "cursor-pointer gap-2",
                                    )}
                                >
                                    <p className="body-s cursor-pointer break-all">
                                        {item.fileSnapshot.name}
                                    </p>
                                    <div className="flex items-center gap-2">
                                        <FileIcon
                                            file={
                                                item.fileSnapshot as FileSnapshot
                                            }
                                            condensed
                                        />
                                        {" · "}
                                        <p className="body-micro subdued cursor-pointer">
                                            {item.draft &&
                                                `${item.draft.status === DraftStatus.IN_PROGRESS ? "Draft in progress" : "Committed draft"}`}
                                            {!item.draft &&
                                                `${item.fileSnapshot.documentType === DocumentType.LABELED ? "Original labeled file" : "Original cleaned file"}`}
                                        </p>
                                    </div>
                                </div>
                            </ActiveEmptyState.RecentlyViewedItem>
                        ))}
                    </ActiveEmptyState.RecentlyViewedList>
                </div>
            )} */}
            {quickActions.length > 0 && (
                <ActiveEmptyState.QuickActionList>
                    {quickActions.map((action) => (
                        <ActiveEmptyState.QuickActionItem
                            href={action.href}
                            label={action.label}
                            isLoading={action.isLoading}
                            key={action.label}
                        />
                    ))}
                </ActiveEmptyState.QuickActionList>
            )}
        </ActiveEmptyState.Container>
    );
}
